export default "__VITE_ASSET__32bc291f__"